import { jsx as n } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import x from "clsx";
import t from "./text.module.less.js";
const u = p(function({ as: o, className: r, size: s = "inherit", weight: e = 400, ...m }, i) {
  const c = o || "p", f = x(
    r,
    t.text,
    t[s],
    t[`weight-${e}`]
  );
  return /* @__PURE__ */ n(c, { className: f, ref: i, ...m });
});
export {
  u as Text
};
//# sourceMappingURL=text.js.map
